import { coachApi } from '@shared/api/client';
import type { StorefrontItem } from './types';
import { adaptStorefrontItemList } from './adapters';

export const storefrontApi = {
  listItems: async (): Promise<StorefrontItem[]> => {
    try {
      const raw = await coachApi.get<unknown>('/webbuilder/storefront/items');
      return adaptStorefrontItemList(raw);
    } catch {
      return [];
    }
  },
  initiateCheckout: (itemId: string): Promise<{ checkout_url: string; session_id: string }> =>
    coachApi.post<{ checkout_url: string; session_id: string }>('/webbuilder/storefront/checkout', { item_id: itemId }),
};

export const webbuilderApi = storefrontApi;
export type * from './types';
